// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountContactModel {
    static getAttributeTypeMap() {
        return AccountContactModel.attributeTypeMap;
    }
}
AccountContactModel.discriminator = undefined;
AccountContactModel.additionalProperties = false;
AccountContactModel.attributeTypeMap = [
    {
        "name": "accountContactId",
        "baseName": "accountContactId",
        "type": "number"
    },
    {
        "name": "roleType",
        "baseName": "roleType",
        "type": "RoleType"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "phoneNumber",
        "baseName": "phoneNumber",
        "type": "string"
    },
    {
        "name": "altPhoneNumber",
        "baseName": "altPhoneNumber",
        "type": "string"
    },
    {
        "name": "email",
        "baseName": "email",
        "type": "string"
    },
];
//# sourceMappingURL=accountContactModel.js.map